/* Aurora — scroll reveals, sticky nav state, accordion, smooth anchors */
(function () {
  if (window.__auroraInit) return;
  window.__auroraInit = true;

  var root = document.documentElement;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduced) root.classList.add('aurora-motion');

  function reveal(scope) {
    var els = (scope || document).querySelectorAll('.aurora [data-reveal]:not(.is-in)');
    if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) els[i].classList.add('is-in');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    for (var j = 0; j < els.length; j++) io.observe(els[j]);
  }

  function nav() {
    var bars = document.querySelectorAll('[data-aurora-nav]');
    if (!bars.length) return;
    var onScroll = function () {
      var stuck = window.scrollY > 24;
      for (var i = 0; i < bars.length; i++) bars[i].classList.toggle('is-stuck', stuck);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    document.querySelectorAll('[data-aurora-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var bar = btn.closest('[data-aurora-nav]');
        if (bar) bar.classList.toggle('is-open');
      });
    });

    navPill();
    sideMode();
  }

  /* Past the hero the top bar steps aside and the line menu takes over
     at the edge of the viewport. Only where a line menu exists. */
  function sideMode() {
    document.querySelectorAll('[data-aurora-nav]').forEach(function (bar) {
      if (bar.__sideBound) return;
      if (!bar.querySelector('[data-aurora-line]')) return;
      bar.__sideBound = true;

      var apply = function () {
        var past = window.scrollY > Math.min(window.innerHeight * 0.62, 560);
        bar.classList.toggle('is-side', past);
        if (past) bar.classList.remove('is-open');
      };
      window.addEventListener('scroll', apply, { passive: true });
      window.addEventListener('resize', apply, { passive: true });
      apply();
    });
  }

  /* Sliding indicator inside the floating pill nav.
     Follows the pointer, and rests on whichever linked section is in view. */
  function navPill() {
    document.querySelectorAll('[data-aurora-links]').forEach(function (wrap) {
      if (wrap.__pillBound) return;
      wrap.__pillBound = true;

      var pill = wrap.querySelector('[data-aurora-pill]');
      var links = [].slice.call(wrap.querySelectorAll('a'));
      if (!pill || !links.length) return;

      var active = null;

      function moveTo(link, show) {
        if (!link || wrap.clientWidth < 2) return;
        var l = link.offsetLeft, w = link.offsetWidth;
        pill.style.transform = 'translateX(' + l + 'px)';
        pill.style.width = w + 'px';
        pill.classList.toggle('is-on', show !== false);
      }

      function rest() {
        if (active) { moveTo(active, true); }
        else { pill.classList.remove('is-on'); }
      }

      links.forEach(function (a) {
        a.addEventListener('mouseenter', function () { moveTo(a, true); });
        a.addEventListener('focus', function () { moveTo(a, true); });
      });
      wrap.addEventListener('mouseleave', rest);

      // the line menu mirrors the same active state, matched on href
      var bar = wrap.closest('[data-aurora-nav]');
      var lineItems = {};
      if (bar) {
        bar.querySelectorAll('[data-aurora-line] a').forEach(function (a) {
          lineItems[a.getAttribute('href') || ''] = a;
        });
      }

      // scroll spy over same-page anchor targets
      var targets = [];
      links.forEach(function (a) {
        var href = a.getAttribute('href') || '';
        if (href.charAt(0) !== '#' || href.length < 2) return;
        var el = document.getElementById(href.slice(1));
        if (el) targets.push({ link: a, el: el, href: href });
      });

      function spy() {
        if (!targets.length) return;
        var line = window.scrollY + window.innerHeight * 0.35;
        var found = null, foundHref = null;
        targets.forEach(function (t) {
          var top = t.el.getBoundingClientRect().top + window.scrollY;
          if (top <= line) { found = t.link; foundHref = t.href; }
        });
        if (found !== active) {
          if (active) active.classList.remove('is-active');
          active = found;
          if (active) active.classList.add('is-active');
          for (var h in lineItems) lineItems[h].classList.remove('is-active');
          if (foundHref && lineItems[foundHref]) lineItems[foundHref].classList.add('is-active');
          if (!wrap.matches(':hover')) rest();
        }
      }

      window.addEventListener('scroll', spy, { passive: true });
      window.addEventListener('resize', function () { rest(); }, { passive: true });
      spy();
      rest();
    });
  }

  function accordion(scope) {
    (scope || document).querySelectorAll('[data-aurora-faq] .au-faq__q').forEach(function (q) {
      if (q.__bound) return;
      q.__bound = true;
      q.addEventListener('click', function () {
        var item = q.parentElement;
        var open = item.classList.contains('is-open');
        item.parentElement.querySelectorAll('.au-faq__item.is-open').forEach(function (o) {
          o.classList.remove('is-open');
          o.querySelector('.au-faq__q').setAttribute('aria-expanded', 'false');
          o.querySelector('.au-faq__a').style.maxHeight = null;
        });
        if (!open) {
          item.classList.add('is-open');
          q.setAttribute('aria-expanded', 'true');
          var a = item.querySelector('.au-faq__a');
          a.style.maxHeight = a.scrollHeight + 'px';
        }
      });
    });
  }

  /* Dot grid: keep the field continuous across sections, and light the
     dots around the pointer. Every section gets it, plus anything marked
     .au-dots-host (the hero card, the footer). */
  var dotsGlobalBound = false;

  function surfaces() {
    return document.querySelectorAll('.aurora:not(.aurora--plain), .au-dots-host');
  }

  function alignDots() {
    var list = surfaces();
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      var gap = parseFloat(getComputedStyle(el).getPropertyValue('--au-dot-gap')) || 30;
      var top = el.getBoundingClientRect().top + window.pageYOffset;
      el.style.setProperty('--au-y', (((top % gap) + gap) % gap) + 'px');
    }
  }

  function dots() {
    var list = surfaces();
    if (!list.length) return;

    var frame = null, queued = null;
    function flush() {
      frame = null;
      if (!queued) return;
      queued.el.style.setProperty('--mx', queued.x + 'px');
      queued.el.style.setProperty('--my', queued.y + 'px');
      queued = null;
    }

    for (var i = 0; i < list.length; i++) {
      (function (el) {
        if (el.__dotsBound) return;
        el.__dotsBound = true;
        el.addEventListener('pointermove', function (e) {
          var r = el.getBoundingClientRect();
          queued = { el: el, x: Math.round(e.clientX - r.left), y: Math.round(e.clientY - r.top) };
          el.classList.add('is-lit');
          if (!frame) frame = requestAnimationFrame(flush);
        }, { passive: true });
        el.addEventListener('pointerleave', function () { el.classList.remove('is-lit'); });
      })(list[i]);
    }

    alignDots();
    if (!dotsGlobalBound) {
      dotsGlobalBound = true;
      window.addEventListener('resize', alignDots, { passive: true });
      window.addEventListener('load', alignDots);
      setTimeout(alignDots, 400);
    }
  }

  function start(scope) { reveal(scope); accordion(scope); dots(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(); nav(); });
  } else { start(); nav(); }

  // Shopify theme editor: re-run when a section is re-rendered
  document.addEventListener('shopify:section:load', function (e) { start(e.target); nav(); });
})();